export const setPageTitle = (txt) => {
  document.title = "Énéfel";
  if (txt) {
    document.title = `${txt} - ${document.title}`;
  }
};
